module.exports = ".row-opp .col-md-2, .row-opp .col-md-1{\r\n    padding:0px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/master-account/new-deposit/new-deposit.component.css
// module id = ./src/app/master-account/new-deposit/new-deposit.component.css
// module chunks = main